import styled from "styled-components";

import { PrimaryHomepageHeader } from "@similarweb/ui-components";

export const StyledHomepageWrapper = styled.div`
    margin-left: 189px;
    position: relative;

    & span[data-automation="Title"] {
        width: 100%;
    }
`;

export const StyledFullWidthWrapper = styled.div`
    display: flex;
    width: 100%;
    cursor: default;
`;

export const StyledPrimaryHomepageWrapper = styled.div`
    & ${PrimaryHomepageHeader} {
        padding-top: 40px !important;
    }
`;
